var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiftLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320-240v-200H120l360-440 360 440H640v200H320Zm80-80h160v-200h111L480-754 289-520h111v200Zm80-217ZM160-80v-80h640v80H160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftLock);
export default __webpack_public_path__ + "static/media/shift_lock.e93b6279eea0b637f7730a14a591b14a.svg";
export { ForwardRef as ReactComponent };